import { render, staticRenderFns } from "./DocFrente.vue?vue&type=template&id=4457859c&scoped=true&"
import script from "./DocFrente.vue?vue&type=script&lang=js&"
export * from "./DocFrente.vue?vue&type=script&lang=js&"
import style0 from "./DocFrente.vue?vue&type=style&index=0&id=4457859c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4457859c",
  null
  
)

export default component.exports